import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl, IntlShape } from 'react-intl';
import { Paper, Tabs, Tab } from '@material-ui/core';
import styled from 'styled-components';

import {
  requestExistantClaims,
  requestValidateExistingClaimDocuments,
} from 'containers/ManagerDocumentsPage/actions';
import { makeSelectExistantClaims } from 'containers/ManagerDocumentsPage/selectors';
import messages from 'containers/ManagerDocumentsPage/messages';
import { translate } from 'containers/services/translate';
import { DOCUMENTS_PANEL } from 'containers/ManagerDocumentsPage/constants';
import DocumentsToValidate from 'containers/ManagerDocumentsPage/DocumentsToValidate';
import ValidatedDocuments from 'containers/ManagerDocumentsPage/ValidatedDocuments';
import RejectedDocuments from 'containers/ManagerDocumentsPage/RejectedDocuments';

const Container = styled(Paper)`
  margin-top: 50px;
  .MuiTabs-flexContainer {
    padding: 0 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .MuiTab-root {
  }
`;

export interface ManagerDocumentsProps {
  intl: IntlShape;
  existantClaims: any;
  requestExistantClaims: Function;
  requestValidateExistingClaimDocuments: Function;
}

export const ManagerDocuments: React.FC<ManagerDocumentsProps> = (
  props,
): JSX.Element => {
  const [tab, setTab] = React.useState(DOCUMENTS_PANEL.PENDING_VALIDATION);

  const handleChange = (event: React.ChangeEvent<{}>, newTab: number) => {
    setTab(newTab);
  };
  return (
    <Container square>
      <Tabs
        value={tab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        className="tab-container"
      >
        <Tab label={translate(messages.pendingDocumentsTabTitle, props)} />
        <Tab label={translate(messages.validatedDocumentsTabTitle, props)} />
        <Tab label={translate(messages.rejectedDocumentsTabTitle, props)} />
      </Tabs>
      {tab === DOCUMENTS_PANEL.PENDING_VALIDATION && (
        <DocumentsToValidate
          existantClaims={props.existantClaims}
          requestExistantClaims={props.requestExistantClaims}
          requestValidateExistingClaimDocuments={
            props.requestValidateExistingClaimDocuments
          }
        />
      )}
      {tab === DOCUMENTS_PANEL.VALIDATED && (
        <ValidatedDocuments
          existantClaims={props.existantClaims}
          requestExistantClaims={props.requestExistantClaims}
        />
      )}
      {tab === DOCUMENTS_PANEL.REJECTED && (
        <RejectedDocuments
          existantClaims={props.existantClaims}
          requestExistantClaims={props.requestExistantClaims}
        />
      )}
    </Container>
  );
};

const mapDispatchToProps = {
  requestExistantClaims,
  requestValidateExistingClaimDocuments,
};

const mapStateToProps = createStructuredSelector({
  existantClaims: makeSelectExistantClaims(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ManagerDocuments));
